var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/inner_shadow.bc3f457b.png","uri@2x": __webpack_public_path__ + "static/media/inner_shadow.c7eb934c.png","uri@3x": __webpack_public_path__ + "static/media/inner_shadow.61d87e48.png",
    width: 253,
    height: 64
});